import { TiChartSeriesComponent } from "../../components/ti-chart-series.component";
import { HighChartDataPoints } from "../../models/data-point/highchart-data-points.model";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { TIComparisonDataModel } from "../../models/data-point/ti-comparison-data.model";

export class TIComparisonDataPointToHighChartDataPointMapper {
    public static map(rawData: TIComparisonDataModel, tiChartSeries: TiChartSeriesComponent): HighChartDataPoints {
        let dataPoints: Array<any> = [];
        for (const data of rawData.points) {
            dataPoints.push(TIComparisonDataPointToHighChartDataPointMapper.toHighChartDataPoint(rawData.ratio, data, tiChartSeries));
        }

        return new HighChartDataPoints({
            points: dataPoints,
            zones: []
        });
    }

    public static toHighChartDataPoint(ratio: number, point: TIChartPointModel, tiChartSeries: TiChartSeriesComponent): any {
        let close = ratio * point.close;
        if (tiChartSeries.chartStyleSettings?.isComparisonSymbolPercentageMode) {
            close = tiChartSeries.highChartComparisonBuilder.getPercentage(point, ratio);
        }
        return { x: point.xValue, y: close };
    }
}